export default __webpack_public_path__ + "static/media/pay-rent-online.325ff6a4.png";